<template>
  <select v-model="model" @change="onSelect" class="form-control">
    <option v-for="(title, value) in options[type]" :value="value">{{ title }}</option>
  </select>
</template>

<script>
export default {
  props: ['type', 'value', 'onChange'],
  data() {
    return {
      model: null,
      options: {
        runner: {
          1: 'Личное старшему курьеру',
          2: 'Личное курьеру',
          3: 'В группу курьерам',
          '-1': 'Не уведомлять',
        },
        supervisor: {
          1: 'Личное контролеру',
          2: 'В группу контролеров',
          '-1': 'Не уведомлять',
        }
      },
    }
  },
  mounted() {
    this.model = this.value;
  },
  methods: {
    onSelect(e) {
      this.onChange(e.target.value);
    }
  }
}
</script>
